import React from 'react'
import { Container } from 'react-bootstrap'
import AdminBoxTop from '../../components/admin/adminBoxTop/AdminBoxTop'
import TabsComponent from '../../components/admin/tabs/Tabs'

const AdminPage = () => {
  return (
    <div className='page-wrapper bg-light'>
      <Container fluid>
        <AdminBoxTop />
        <TabsComponent />
      </Container>
    </div>
  )
}

export default AdminPage